import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { RichTextViewerWithFetch } from './RichTextViewerWithFetch/RichTextViewerWithFetch';
export const { RichTextViewerModalTID } = getTestIds();
export default function RichTextViewerModal(param) {
    let { title, text, fetchText, onClose, queryKey } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'rich_text_viewer_confirm'
            },
            secondaryButton: {
                name: 'rich_text_viewer_cancel'
            }
        },
        overflowContent: true,
        contentPadding: "small",
        width: "800px",
        height: "calc(100% - 128px)",
        title: title,
        onCloseButtonClick: onClose,
        testId: RichTextViewerModalTID.Root(),
        content: /*#__PURE__*/ _jsx("div", {
            "data-testid": RichTextViewerModalTID.Content(),
            style: {
                width: '100%',
                textAlign: 'left'
            },
            children: /*#__PURE__*/ _jsx(RichTextViewerWithFetch, {
                queryKey: queryKey,
                text: text,
                fetchText: fetchText
            })
        })
    });
}
